import { css } from 'styled-components'

export const breakpoints = {
  extraSmall: 320,
  small: 500,
  medium: 700,
  large: 1000,
  extraLarge: 1400,
}

export const browserIs = () => {
  const browserIs = {
    greaterThan: {},
    lessThan: {},
  }

  Object.keys(breakpoints).forEach((breakpoint, index) => {
    if (window.matchMedia(`(min-width: ${breakpoints[breakpoint]}px)`).matches) {
      browserIs.greaterThan[breakpoint] = true
    } else {
      browserIs.greaterThan[breakpoint] = false
    }

    if (window.matchMedia(`(max-width: ${breakpoints[breakpoint]}px)`).matches) {
      browserIs.lessThan[breakpoint] = true
    } else {
      browserIs.lessThan[breakpoint] = false
    }
  })

  return browserIs
}

// iterate through the sizes and create a media template
export const media = Object.keys(breakpoints).reduce((accumulator, label) => {
  const size = breakpoints[label]
  accumulator.greaterThan = accumulator.greaterThan || {}
  accumulator.greaterThan[label] = (...args) => css`
    @media (min-width: ${size}px) {
      ${css(...args)}
    }
  `
  return accumulator
}, {})



// WEBPACK FOOTER //
// ./src/tools/browser.js